<template>
  <div class="card border-0 shadow-sm">
    <div class="d-flex justify-content-between">
      <h6 class="card-header bg-transparent border-0">Filters</h6>
      <button @click="copyUrl" :disabled="urlCopied" class="btn btn-primary btn-sm me-3" :class="urlCopied ? 'btn-success' : 'btn-primary'">
        <span v-if="!isLoadingLink">{{ urlCopied ? 'Url copied!' : 'Copy link' }}</span>
        <div v-if="isLoadingLink" class="text-center">
        <div class="spinner-border" role="status" style="width: 24px; height: 24px">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      </button>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-md-2 mb-1">
          <label for="Part-of-day" class="mb-1 text-secondary">Part of day</label>
          <v-select v-model="setDatePart" :options="datePartOptions" :clearable="false" />
        </div>
        <div class="col-12 col-md-2 mb-1 text-secondary">
          <label for="Session-type" class="mb-1">Session type</label>
          <v-select v-model="setSession" :options="sessionOptions" :clearable="false" />
        </div>
        <div class="col-12 col-md-2 mb-1 text-secondary">
          <label for="Classroom-type" class="mb-1">Classroom type</label>
          <v-select v-model="setClassroom" :options="classroomOptions" :clearable="false" />
        </div>
        <div class="col-12 col-md-2 mb-1 text-secondary">
          <label for="Level" class="mb-1">Level</label>
          <v-select v-model="setLevel" :options="levelOptions" :clearable="false" />
        </div>
        <div class="col-12 col-md-2 mb-1">
          <label for="Month" class="mb-1 text-secondary">Month</label>
          <v-select v-model="setMonth" :options="monthOptions" :clearable="false" label="monthName">
            <template #option="{ monthName, year }">
              <div class="d-flex justify-content-between">
                <span>{{ monthName }}</span>
                <small class="text-secondary"> {{ year }}</small>
              </div>
            </template>
          </v-select>
        </div>
        <div class="col-12 col-md-2 mb-1">
          <label for="Month" class="mb-1 text-secondary">Search</label>
          <input v-model="setSearch" class="form-control" placeholder="Search..." style="height: 34px" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    vSelect,
  },
  props: ['datePart', 'classroom_type', 'session_type', 'level', 'month', 'search', 'datePartOptions', 'sessionOptions', 'classroomOptions', 'levelOptions', 'monthOptions'],
  data() {
    return {
      urlParams: new URLSearchParams(window.location.search),
      urlCopied: false,
      isLoadingLink: false,
    }
  },
  mounted() {
    /* For some reason these loops didn't work while individual deleting to each params works fine */

    // const paramArray = ['part_date', 'session_type', 'classroom_type', 'level', 'month', 'seach']
    // for (let i = 0; i < paramArray.length; i++) {
    //   this.urlParams.delete(i)
    // }

    // this.urlParams.forEach((val, key) => {
    //   this.urlParams.delete(key)
    // })
    setTimeout(() => {
      this.urlParams.delete('part_date')
      this.urlParams.delete('session_type')
      this.urlParams.delete('classroom_type')
      this.urlParams.delete('level')
      this.urlParams.delete('month')
      this.urlParams.delete('search')
      this.urlParams.set('?part_date', this.datePart.value)
      this.urlParams.set('classroom_type', this.classroom_type.value ? this.classroom_type.value : '')
      this.urlParams.set('session_type', this.session_type.value ? this.session_type.value :   '')
      this.urlParams.set('level', this.level.value ? this.level.value : '')
      this.urlParams.set('month', this.month.value ? this.month.value : '')
      this.urlParams.set('search', this.search ? this.search : '')
      window.history.replaceState(null, null, decodeURIComponent(this.urlParams))
    }, 500)

  },
  computed: {
    setDatePart: {
      get () { return this.datePart },
      set (value) { this.setValue('?part_date', value, 'update:datePart') },
    },
    setClassroom: {
      get () { return this.classroom_type },
      set (value) { this.setValue('classroom_type', value, 'update:classroom_type') },
    },
    setSession: {
      get () { return this.session_type },
      set (value) { this.setValue('session_type', value, 'update:session_type') },
    },
    setLevel: {
      get () { return this.level },
      set (value) { this.setValue('level', value, 'update:level') },
    },
    setMonth: {
      get () { return this.month },
      set (value) { this.setValue('month', value, 'update:month') },
    },
    setSearch: {
      get () { return this.search },
      set (value) { this.setValue('search', value, 'update:search') },
    },
  },
  methods: {
    setValue(param, value, emitUpdate) {
      this.urlCopied = false
      this.urlParams.set(param, param !== 'search' ? value.value : value)
      window.history.replaceState(null, null, decodeURIComponent(this.urlParams))
      this.$emit(emitUpdate, value)
    },
    copyUrl() {
      this.isLoadingLink = true
      // process.env.VUE_APP_WEBSITEURL
      const payload = {
        group_guid: 'Bmb126xbXHa',
        domain: 'bit.ly',
        long_url: process.env.VUE_APP_WEBSITEURL + window.location.search,
      }
      fetch(`https://api-ssl.bitly.com/v4/shorten`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer 56676576df926c0c6a32c8bbf124c8d78532297d',
        },
        body: JSON.stringify(payload)
      })
      .then(response => response.json().then(res => {
        this.isLoadingLink = false
        this.urlCopied = true
        navigator.clipboard.writeText(res.link)
      }))
      
    },
  },
}
</script>
<style scoped lang="css"  src="../assets/bootstrap.min.css"></style>
<style>
/* .vs__dropdown-option:hover {
  background-color: #92434e !important;
} */
</style>
<style scoped>
.btn-primary {
  background-color: #92434e;
  border: #92434e;
}
.btn-primary:hover {
  background-color: #cb5e6d;
  border: #cb5e6d;
}
.btn-primary:focus {
  outline: none;
}
.btn:focus {
  outline: none;
  box-shadow: none;
}
</style>

